import { Box, CircularProgress } from '@mui/material'

const InlineLoader = () => (
  <Box sx={{ mx: 1, display: 'inline' }}>
    <CircularProgress size="1rem" />
  </Box>
)

export default InlineLoader
